// Centralized brand constants for Infolocus
export const BRAND = {
  tradeName: "Infolocus",
  legalName: "Infolocus Business Consulting Private Limited",
  slogan: "Transform Automate Grow",
  positioning: "Digital Transformation for Indian SMEs",
  phone: "+91-7021880155",
  phoneDigits: "917021880155",
  emailPublic: "contact@infolocus.in",
  website: "infolocus.in",
  websiteUrl: "https://infolocus.in",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_infolocus-sme/artifacts/pjnt8j4f_infolocus%20logo%20transparent%20cropped.png",
  heroBgUrl:
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhYnN0cmFjdCUyMGRhdGElMjB0ZWNobm9sb2d5fGVufDB8fHx8MTc4MDU5NTM4N3ww&ixlib=rb-4.1.0&q=85",
  meetingImageUrl:
    "https://images.unsplash.com/flagged/photo-1576485436509-a7d286952b65?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMG1lZXRpbmd8ZW58MHx8fHwxNzgwNTk1Mzg3fDA&ixlib=rb-4.1.0&q=85",
  marketingImageUrl:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxkaWdpdGFsJTIwbWFya2V0aW5nJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4MDU5NTM4N3ww&ixlib=rb-4.1.0&q=85",
  whatsappMessage:
    "Hi Infolocus, I would like to learn more about your digital transformation services for my business.",
};

export const SERVICES = [
  {
    id: "enterprise-saas",
    eyebrow: "01",
    title: "Enterprise SaaS",
    subtitle: "Third‑Party & Custom Built",
    description:
      "Deploy proven enterprise platforms or build SaaS purpose‑built for your operations. We integrate, customise and own the rollout end‑to‑end.",
    bullets: [
      "Third‑Party Enterprise SaaS implementation",
      "Custom Enterprise SaaS engineered for your workflows",
      "API integrations, SSO, role‑based access",
    ],
    span: "lg:col-span-3",
  },
  {
    id: "agentic-ai",
    eyebrow: "02",
    title: "Agentic AI Workflow Automation",
    subtitle: "Autonomous agents for the back office",
    description:
      "Replace repetitive workflows with AI agents that reason, act and report — across operations, finance, support and sales.",
    bullets: [
      "Multi‑agent orchestration",
      "Document, ticket & approval automation",
      "Human‑in‑the‑loop guardrails",
    ],
    span: "lg:col-span-3",
  },
  {
    id: "data-management",
    eyebrow: "03",
    title: "Data Management",
    subtitle: "Cloud, Storage & Virtualization",
    description:
      "Migrate to a modern data centre or cloud, consolidate storage and virtualize your stack — secure, performant and audit‑ready.",
    bullets: [
      "Migration to Data Centre or Cloud",
      "Storage Solutions & Backup",
      "Virtualization & Infrastructure Modernisation",
    ],
    span: "lg:col-span-4",
  },
  {
    id: "digital-marketing",
    eyebrow: "04",
    title: "Digital Marketing Suite",
    subtitle: "Lemonsqueezy Marketing Labs",
    description:
      "A full‑stack growth practice — performance marketing, content, SEO and lifecycle — engineered to compound pipeline month on month.",
    bullets: [
      "Performance & paid acquisition",
      "Content, SEO & lifecycle marketing",
      "Attribution & analytics dashboards",
    ],
    span: "lg:col-span-2",
  },
];

export const INDUSTRIES = [
  "Manufacturing",
  "Retail & D2C",
  "Healthcare",
  "Financial Services",
  "Logistics",
  "Real Estate",
  "Education",
  "Hospitality",
  "Professional Services",
  "Pharma",
  "Engineering",
  "FMCG",
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Discover",
    desc: "We audit your operations, data and growth funnels — and align on the metrics that matter.",
  },
  {
    n: "02",
    title: "Design",
    desc: "A blueprint for the right SaaS, AI agents, data architecture and marketing engine.",
  },
  {
    n: "03",
    title: "Deploy",
    desc: "We build, integrate and ship — with security, change management and training baked in.",
  },
  {
    n: "04",
    title: "Grow",
    desc: "We instrument, iterate and compound results across automation, data and demand.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Rajesh Iyer",
    title: "Director of Operations",
    company: "Pratham Industries",
    industry: "Manufacturing, Pune",
    quote:
      "Infolocus replaced four disconnected tools with a single SaaS rollout and AI agents on top. Our order‑to‑dispatch cycle is 41% faster, and we finally have one number we trust.",
  },
  {
    name: "Ananya Krishnan",
    title: "Co‑founder & CMO",
    company: "Saanvi Wellness",
    industry: "D2C Retail, Bengaluru",
    quote:
      "The Lemonsqueezy Marketing Labs team operates like an in‑house growth pod. CAC dropped 28% in two quarters and we know exactly which channel drove which rupee.",
  },
  {
    name: "Vikram Shetty",
    title: "Chief Financial Officer",
    company: "Aaroh Logistics",
    industry: "Logistics, Mumbai",
    quote:
      "Migrating our data to cloud felt risky — until Infolocus mapped every workflow first. Zero downtime, audit‑ready storage, and reports my board actually reads.",
  },
  {
    name: "Dr. Meera Bansal",
    title: "Managing Director",
    company: "Nirvana Diagnostics",
    industry: "Healthcare, Delhi NCR",
    quote:
      "Their agentic AI automation now handles patient intake, insurance pre‑auth and follow‑ups. We freed up almost two FTEs of work without touching headcount.",
  },
];

export const WHY_POINTS = [
  {
    title: "SME‑first by design",
    desc: "Solutions sized and priced for Indian SMEs — no enterprise bloat, no consulting theatre.",
  },
  {
    title: "One accountable partner",
    desc: "SaaS, AI, data and demand — under a single roof and a single delivery owner.",
  },
  {
    title: "Outcomes, not output",
    desc: "We commit to business KPIs — cycle time, CAC, uptime, cost per transaction.",
  },
  {
    title: "Built for Bharat",
    desc: "GST, regional language ops, multi‑location logistics — handled out of the box.",
  },
  {
    title: "Security & compliance",
    desc: "Audit‑ready by default — role based access, encryption and DPDP‑aware design.",
  },
  {
    title: "Compounding ROI",
    desc: "Each engagement layers on the previous one. Automation today, AI agents next, growth always.",
  },
];
